import * as React from 'react';
import { Col, Row } from 'antd';
import { observer } from 'mobx-react';

import { DataLocalService } from 'src/core/services/data-local.service';
import { BooleanView } from 'src/core/ui/boolean.view';
import { DataTableView, Column, ToolbarVisibility, MenuItem } from 'src/core/ui/data-table.view';
import { TooltipView } from 'src/core/ui/tooltip.view';

interface SearchOccupancyProps {
	extraColumns?: Column[];
	paxs: PersonOccupancy[];
	occupancies: Occupancy[]
	setBusy(isBusy: boolean);
	type: SearchType;
	lockUnits?: boolean;
	extraToolbarCmd?: MenuItem[];
}

@observer
export class SearchOccupancyView extends React.Component<SearchOccupancyProps, {}> {
	constructor(props: Readonly<SearchOccupancyProps>) {
		super(props);
	}

	private get columns(): Column[] {
		let firstColumn;

		switch (this.props.type) {
			case 'Accommodation':
				firstColumn = 'Rooms';
				break;
			case 'CarRent':
				firstColumn = 'Cars';
				break;
			case 'Transfer':
			case 'General':
				firstColumn = 'Units';
				break;
			case 'Flights':
				firstColumn = 'Flights';
				break;
		}

		return (this.props.extraColumns || [])
			.concat([{
				key: 'unit',
				title: firstColumn,
				dataIndex: 'unit'
			}].concat(this.props.paxs.map(e => ({
				key: e.id,
				title: (
					<TooltipView title={`${e.name} (${e.age})`}>
						<span>{e.name}</span>
					</TooltipView>
				),
				dataIndex: e.id,
				render: (text: string, record: Occupancy, index: number) => (
					<BooleanView
						mode="edit"
						value={record.paxs.some(p => p.id === e.id)}
						onChanged={newVal => {
							const occupancy = this.props.occupancies.find(o => o.unit == record.unit);
							if (newVal) {
								for (const occupancy1 of this.props.occupancies) {
									const paxIndex = occupancy1.paxs.findIndex(p => p.id == e.id);
									if (paxIndex != -1) {
										occupancy1.paxs.splice(paxIndex, 1);
										this.forceUpdate();
									}
								}
								const pax = this.props.paxs.find(p => p.id == e.id);
								occupancy.paxs.push(pax);
							} else {
								const paxIndex = occupancy.paxs.findIndex(p => p.id == e.id);
								occupancy.paxs.splice(paxIndex, 1);
							}
						}}
					/>
				)
			}))));
	}

	private get dataSet(): DataLocalService<any> {
		return new DataLocalService(this.props.occupancies);
	}

	createOccupancy = (): Promise<Occupancy[]> => {
		let max = 0;
		for (const occupancy of this.props.occupancies) {
			if (occupancy.unit > max) {
				max = occupancy.unit;
			}
		}

		this.props.occupancies.push({ ...this.props.occupancies[0], unit: max + 1, paxs: [] });
		return Promise.resolve(this.props.occupancies);
	}

	render() {
		if (this.props.occupancies == null) {
			return null;
		}

		let visibility = ToolbarVisibility.hideSearch | ToolbarVisibility.hidePagination;
		if (this.props.lockUnits) {
			visibility |= ToolbarVisibility.hideModifyButtons;
		}
		return (
			<Row>
				<Col xs={24}>
					<DataTableView
						rowKey="unit"
						mode="edit"
						setBusy={this.props.setBusy}
						columns={this.columns}
						model={this.dataSet}
						createNewItem={this.createOccupancy}
						hideToolbar={visibility}
						toolbarLeftItems={this.props.extraToolbarCmd}
					/>
				</Col>
			</Row>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/bookings/search/search-occupancy.view.tsx